import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "@remix-run/react"

import Notification from "../notification";
import LogoutIcon from "../icons/logoutIcon";
import { withInternetCheck } from "../utilis";

interface HeaderProps {
  expireCookie: string;
  isAdmin: boolean;
  userProfileImage: any;
}

const Header: React.FC<HeaderProps> = ({ expireCookie, isAdmin, userProfileImage }) => {
  const [pop, setPop] = useState(false)
  const [activePage, setActivePage] = useState("");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isUserOffline, setIsUserOffline] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const email = window.localStorage.getItem('emailForSignIn');
    setEmail(email || "");
  }, [isAdmin])

  useEffect(() => {
    if (location?.pathname) {
      setActivePage(location.pathname)
    } else {
      setActivePage("/dashboard")
    }
  }, [navigate, location?.pathname])

  const GoToLoginAction = () => {
    setPop(false);
    expireCookie();
    navigate("/login");
  }

  const goToHomePageAction = () => {
    setActivePage("/");
    navigate("/");
  }

  const goToDashBoardAction = () => {
    setActivePage("/")
    navigate("/")
  }

  const goToCreatorPageAction = () => {
    setActivePage("/creators")
    navigate("/creators")
  }

  const goToPendingRequestAction = () => {
    setActivePage("/request")
    navigate("/request")
  }

  const GoToLoginActionAction = () => {
    navigate("/profile");
    setPop(false);
    setActivePage("profile");
  }

  // Offline Notiifcation
  const offlineNotification = () => {
    setIsUserOffline(true);
  };

  const goToHomePage = () => {
    withInternetCheck(navigator, goToHomePageAction, "", offlineNotification);
  }

  const goToDashBoard = () => {
    withInternetCheck(navigator, goToDashBoardAction, "", offlineNotification);
  }

  const goToCreatorPage = () => {
    withInternetCheck(navigator, goToCreatorPageAction, "", offlineNotification);
  }

  const GoToLogin = () => {
    withInternetCheck(navigator, GoToLoginAction, "", offlineNotification);
  }

  const goToUserProfilePage = () => {
    withInternetCheck(navigator, GoToLoginActionAction, "", offlineNotification);
  }

  const goToPendingRequest = () => {
    withInternetCheck(navigator, goToPendingRequestAction, "", offlineNotification);
  }

  const closeNotificationModal = () => {
    setIsUserOffline(false);
  }

  return (
    <div className="w-full relative bg-header-bg py-[22px] px-[60px] flex items-center justify-between">

      {/* logo */}
      <button className="flex items-center w-[100px] h-full" onClick={() => goToHomePage()}>
        <img src="/images/aaoNxt-logo.png" alt="logo" />
      </button>

      {/* menu options */}
      <ul className="flex flex-grow ml-[100px] gap-x-[30px] items-center">
        <li className={`text-lg font-medium ${activePage === "/" ? "text-primary" : "text-header-text"} leading-4 hover:cursor-pointer`} onClick={() => goToDashBoard()}>Dashboard</li>
        <li className={`text-lg font-medium ${activePage.includes("/creators") ? "text-primary" : "text-header-text"} ${isAdmin ? "flex" : "hidden"} leading-4 hover:cursor-pointer`} onClick={() => goToCreatorPage()}>Creators</li>
        <li className={`text-lg font-medium ${activePage.includes("/request") ? "text-primary" : "text-header-text"} ${isAdmin ? "flex" : "hidden"} leading-4 hover:cursor-pointer`} onClick={() => goToPendingRequest()}>Pending Request</li>
      </ul>

      {/* profile icon */}
      <div className="relative">
        {userProfileImage?.includes("https://") ? (
          <button
          className="w-[36px] h-[36px] rounded-[50px] font-bold"
          onClick={() => setPop(!pop)}
        >
        <img src={userProfileImage} className="w-[36px] h-[36px] rounded-[50px]" />
        </button>
        ) : (
          <button
          className="w-[36px] h-[36px] rounded-[50px] bg-primary ml-[80px] text-white font-bold"
          onClick={() => setPop(!pop)}
        >{email?.charAt(0)?.toUpperCase()}</button>
        )
        }
        {
          <>
            {
              pop ? (
                <div className="w-[300px] absolute h-auto bg-header-bg z-[9999] top-[70px] right-[0px] rounded-b-lg border border-gray-400">

                  {/* profile */}
                  <div className={`w-full ${isAdmin ? "hidden" : "flex"}`}>
                    <button className="w-full flex gap-x-2 items-center border-b border-b-light-black p-2" onClick={() => goToUserProfilePage()}>
                      {
                        userProfileImage?.includes("https://") ? (
                          <button
                            className="w-[36px] h-[36px] rounded-[50px] bg-primary ml-[8px] text-white font-bold"
                            onClick={() => setPop(!pop)}
                          >
                            <img
                              src={userProfileImage}
                              className="w-[36px] h-[36px] rounded-[50px]"
                              alt="Profile"
                            />
                          </button>
                        ) : (
                          <button className="w-[40px] h-[40px] rounded-[100%] bg-primary text-[#ffff] font-bold">
                            {email?.charAt(0)?.toUpperCase()}
                          </button>
                        )
                      }
                      <button className={`ml-[8px] ${activePage.includes("/profile") ? "text-primary font-semibold text-[16px]" : "text-[#ffff] font-semibold"}`}>Profile</button>
                    </button>
                  </div>

                  {/* sign out icon */}
                  <div className="w-full">
                    <button className="w-full p-[20px] flex items-center gap-x-[20px]" onClick={() => GoToLogin()}>
                      <span className="max-w-[24px] h-[24px] text-[#ffff]">
                        <LogoutIcon />
                      </span>
                      <span className="font-semibold text-[16px] mb-0 text-[#ffff]">Sign Out</span>
                    </button>
                  </div>

                </div>
              ) : ""
            }
          </>
        }
      </div>

      {
        isUserOffline ? (
          <Notification variant="error" title="No Internet Connection" description="You are Offline Kindly Check Your Internet Connection" onClose={closeNotificationModal} />
        ) : (
          ''
        )
      }
    </div>
  )
}

export default Header
